declare namespace $ {

	export class $giper_balls_ball extends $mol_view {
		image( ): string
		state( ): string
		focus( ): boolean
		mood( ): string
		kind( ): number
		colors( ): readonly(string)[]
		style( ): ({ 
			'background-image': ReturnType< $giper_balls_ball['image'] >,
		}) 
		active( ): boolean
		attr( ): ({ 
			'giper_balls_ball_state': ReturnType< $giper_balls_ball['state'] >,
			'giper_balls_ball_focus': ReturnType< $giper_balls_ball['focus'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=ball.view.tree.d.ts.map